import React from 'react';
import RoadmapTimeline from './components/RoadmapTimeline';

export default function FullStackEngineerRoadmapDisplay({ roadmap, maxMonth, isUnlocked, roleKey }) {
  return (
    <RoadmapTimeline
      roadmap={roadmap}
      title={`Your ${roadmap?.totalMonths || 6}-Month Full-Stack Engineer Career Roadmap`}
      subtitle="Full-Stack Engineering Journey"
      maxMonth={maxMonth}
      isUnlocked={isUnlocked}
      fileName="tekyu-full-stack-engineer-roadmap.pdf"
      roleKey={roleKey || "fullstackengineer"}
    />
  );
}

